export default [
  {
    EQUIPOS: 'AIR & OCEAN',
    NUM: '1',
    NOMBRE: 'Arturo',
    APELLIDOS: 'Chavez',
    CARGO: 'Co-Fundador y Director de Desarrollo de Negocio',
    CARGO_EN: 'Co-Founder & Business Development Manager',
    EMAIL: 'arturo.chavez@3lglogistics.com',
    TELÉFONO: '+34 687 87 46 09',
  },
  {
    EQUIPOS: 'AIR & OCEAN',
    NUM: '2',
    NOMBRE: 'Ricardo',
    APELLIDOS: 'Sánchez ',
    CARGO: 'Director de Carga Aérea',
    CARGO_EN: 'Airfreight Operations Manager',
    EMAIL: 'ricardo.sanchez@3lglogistics.com',
    TELÉFONO: '+34 649 85 69 15',
  },
  {
    EQUIPOS: 'AIR & OCEAN',
    NUM: '3',
    NOMBRE: 'Celia',
    APELLIDOS: 'Ballega',
    CARGO: 'Directora de Carga Marítima',
    CARGO_EN: 'Seafreight Operations Manager',
    EMAIL: 'celia.ballega@3lglogistics.com',
    TELÉFONO: '+34 660 02 31 60',
  },
  {
    EQUIPOS: 'AIR & OCEAN',
    NUM: '4',
    NOMBRE: 'Carolina',
    APELLIDOS: 'Morales ',
    CARGO: 'Operaciones de Carga Aérea',
    CARGO_EN: 'Airfreight Coordinator',
    EMAIL: 'carolina.morales@3lglogistics.com',
    TELÉFONO: '+34 628 060 055',
  },
  {
    EQUIPOS: 'AIR & OCEAN',
    NUM: '5',
    NOMBRE: 'Carolina',
    APELLIDOS: 'Moreno ',
    CARGO: 'Directora de Relaciones Comerciales',
    CARGO_EN: 'Customer Relationship Manager',
    EMAIL: 'carolina.moreno@3lglogistics.com',
    TELÉFONO: '+34 626 76 85 30',
  },
  {
    EQUIPOS: 'AIR & OCEAN',
    NUM: '6',
    NOMBRE: 'Cristina',
    APELLIDOS: 'Aquilina ',
    CARGO: 'Directora de Servicio al Cliente y Cotizaciones Marítimas',
    CARGO_EN: 'Pricing & Inside sales Manager',
    EMAIL: 'cristina.aquilina@3lglogistics.com',
    TELÉFONO: '+34 680 22 97 10',
  },
  {
    EQUIPOS: 'AIR & OCEAN',
    NUM: '7',
    NOMBRE: 'Martí',
    APELLIDOS: 'Ros ',
    CARGO: 'Cotizaciones Marítimas y  Servicio al Cliente',
    CARGO_EN: 'Customer Service & Inside Sales',
    EMAIL: 'marti.ros@3lglogistics.com',
    TELÉFONO: '+34 683 34 97 67',
  },
  {
    EQUIPOS: 'AIR & OCEAN',
    NUM: '8',
    NOMBRE: 'Laura',
    APELLIDOS: 'Flores ',
    CARGO: 'Operaciones de Carga Marítima',
    CARGO_EN: 'Seafreight Coordinator',
    EMAIL: 'laura.flores@3lglogistics.com',
    TELÉFONO: '+34 628 03 56 12',
    undefined: '16',
  },
  {
    EQUIPOS: 'TERRESTRE INTERNACIONAL',
    NUM: '9',
    NOMBRE: 'Lluis',
    APELLIDOS: 'Gay',
    CARGO: 'CEO',
    CARGO_EN: 'CEO',
    EMAIL: 'lluis.gay@3lglogistics.com',
    TELÉFONO: '+34 609 31 90 18',
  },
  {
    EQUIPOS: 'TERRESTRE INTERNACIONAL',
    NUM: '10',
    NOMBRE: 'Alfonso',
    APELLIDOS: 'Díaz ',
    CARGO: 'Director Administrativo Financiero',
    CARGO_EN: 'Financial Administrative Director',
    EMAIL: 'alfonso.diaz@3lglogistics.com',
    TELÉFONO: '+34 628 56 59 87',
  },
  {
    EQUIPOS: 'TERRESTRE INTERNACIONAL',
    NUM: '11',
    NOMBRE: 'Ferran',
    APELLIDOS: 'Martinez ',
    CARGO: 'Director cargas parciales y completas',
    CARGO_EN: 'LTL & FTL Manager',
    EMAIL: 'ferran.martinez@3lglogistics.com',
    TELÉFONO: '+34 628 06 91 45',
  },
  {
    EQUIPOS: 'TERRESTRE INTERNACIONAL',
    NUM: '12',
    NOMBRE: 'Gemma',
    APELLIDOS: 'Cañas ',
    CARGO: 'Coordinación LTL & FTL',
    CARGO_EN: 'LTL & FTL Coordinator',
    EMAIL: 'gemma.canas@3lglogistics.com',
    TELÉFONO: '+34 680 76 03 36',
  },
  {
    EQUIPOS: 'TERRESTRE INTERNACIONAL',
    NUM: '13',
    NOMBRE: 'Neus',
    APELLIDOS: 'Pérez ',
    CARGO: 'Attención Cliente',
    CARGO_EN: 'Customer Service',
    EMAIL: 'neus.perez@3lglogistics.com',
    TELÉFONO: ' +34 682 90 01 38',
  },
  {
    EQUIPOS: 'TERRESTRE INTERNACIONAL',
    NUM: '14',
    NOMBRE: 'Joan',
    APELLIDOS: 'Bosch ',
    CARGO: 'Director Comercial',
    CARGO_EN: 'Sales Manager',
    EMAIL: 'joan.bosch@3lglogistics.com',
    TELÉFONO: '+34 629 41 12 80',
  },
  {
    EQUIPOS: 'TERRESTRE INTERNACIONAL',
    NUM: '15',
    NOMBRE: 'Carles',
    APELLIDOS: 'Muñoz',
    CARGO: 'Director Desarrollo Comercial',
    CARGO_EN: 'Business Development Manager',
    EMAIL: 'carles.munoz@3lglogistics.com',
    TELÉFONO: '+34 609 90 67 12',
    undefined: '14',
  },
  {
    EQUIPOS: 'TERRESTRE INTERNACIONAL',
    NUM: '16',
    NOMBRE: 'Jordi',
    APELLIDOS: 'Obach',
    CARGO: 'Director General',
    CARGO_EN: 'Managing Director',
    EMAIL: 'jordi.obach@3lglogistics.com',
    TELÉFONO: '+34 659 96 94 30',
  },
  {
    EQUIPOS: 'TERRESTRE NACIONAL',
    NUM: '16',
    NOMBRE: 'Jordi',
    APELLIDOS: 'Obach',
    CARGO: 'Director General',
    CARGO_EN: 'Managing Director',
    EMAIL: 'jordi.obach@3lglogistics.com',
    TELÉFONO: '+34 659 96 94 30',
  },
  {
    EQUIPOS: 'TERRESTRE NACIONAL',
    NUM: '17',
    NOMBRE: 'Ana',
    APELLIDOS: 'Sancho ',
    CARGO: 'Administrativo Financiero',
    CARGO_EN: 'Finance Administrator',
    EMAIL: 'ana.sancho@3lglogistics.com',
    TELÉFONO: '+34 630 28 53 89',
  },
  {
    EQUIPOS: 'TERRESTRE NACIONAL',
    NUM: '18',
    NOMBRE: 'Montse',
    APELLIDOS: 'Garrido ',
    CARGO: 'Atención al Cliente',
    CARGO_EN: 'Customer Service',
    EMAIL: 'montse.garrido@3lglogistics.com',
    TELÉFONO: '+34 696 27 81 16',
  },
  {
    EQUIPOS: 'TERRESTRE NACIONAL',
    NUM: '19',
    NOMBRE: 'Marc',
    APELLIDOS: 'Ortega',
    CARGO: 'Director Comercial Terrestre',
    CARGO_EN: 'Land Sales Manager',
    EMAIL: 'marc.ortega@3lglogistics.com',
    TELÉFONO: '+34 609 26 39 19',
  },
  {
    EQUIPOS: 'TERRESTRE NACIONAL',
    NUM: '20',
    NOMBRE: 'Luis',
    APELLIDOS: 'García',
    CARGO: 'Director Tráfico',
    CARGO_EN: 'Traffic Director',
    EMAIL: 'luis.garcia@3lglogistics.com',
    TELÉFONO: '+34 618 57 66 45',
  },
  {
    EQUIPOS: 'TERRESTRE NACIONAL',
    NUM: '21',
    NOMBRE: 'Ivan',
    APELLIDOS: 'Bravo ',
    CARGO: 'Coordinador Tráfico',
    CARGO_EN: 'Traffic Coordinator',
    EMAIL: 'ivan.bravo@3lglogistics.com',
    TELÉFONO: '+34 628 37 59 68',
    undefined: '12',
  },
  {
    EQUIPOS: 'ALMACÉN',
    NUM: '22',
    NOMBRE: 'Ricardo',
    APELLIDOS: 'Fernández ',
    CARGO: 'Responsable operaciones almacén',
    CARGO_EN: 'Warehouse Operations Manager',
    EMAIL: 'ricardo.fernandez@3lglogistics.com',
    TELÉFONO: '+34 648 038 968',
  },
  {
    EQUIPOS: 'ALMACÉN',
    NUM: '23',
    NOMBRE: 'Jose Antonio',
    APELLIDOS: 'Porras ',
    CARGO: 'Director Recogidas y Entregas',
    CARGO_EN: 'Pick-ups & Deliveries Manager',
    EMAIL: 'joseantonio.porras@3lglogistics.com',
    TELÉFONO: '+34 646 82 31 20',
  },
  {
    EQUIPOS: 'ALMACÉN',
    NUM: '24',
    NOMBRE: 'Juanjo',
    APELLIDOS: 'Gutiérrez ',
    CARGO: 'Coordinador Almacén',
    CARGO_EN: 'Traffic Coordinator',
    EMAIL: 'juanjo.gutierrez@3lglogistics.com',
    TELÉFONO: '+34 626 45 93 18',
  },
  {
    EQUIPOS: 'ALMACÉN',
    NUM: '25',
    NOMBRE: 'Alejandro',
    APELLIDOS: 'Benítez ',
    CARGO: 'Documentación',
    CARGO_EN: 'Documentation',
    EMAIL: 'alejandro.benitez@3lglogistics.com',
    TELÉFONO: '+34 626 45 93 18',
  },
  {
    EQUIPOS: 'ALMACÉN',
    NUM: '26',
    NOMBRE: 'José',
    APELLIDOS: 'Navarro',
    CARGO: 'Gestor Recogidas y Entregas',
    CARGO_EN: 'Pick-ups and Deliveries Managing',
    EMAIL: 'jose.navarro@3lglogistics.com',
    TELÉFONO: '+34 638 03 94 62',
  },
  {
    EQUIPOS: 'ALMACÉN',
    NUM: '27',
    NOMBRE: 'Jordi',
    APELLIDOS: 'Díaz    ',
    CARGO: 'Operario Almacén',
    CARGO_EN: 'Warehouse Operations',
    EMAIL: 'info@3lglogistics.com',
    TELÉFONO: '+34 93 712 86 86',
  },
  {
    EQUIPOS: 'ALMACÉN',
    NUM: '28',
    NOMBRE: 'Luís',
    APELLIDOS: 'Mota',
    CARGO: 'Operario Almacén',
    CARGO_EN: 'Warehouse Operations',
    EMAIL: 'info@3lglogistics.com',
    TELÉFONO: '+34 93 712 86 86',
  },
  {
    EQUIPOS: 'ALMACÉN',
    NUM: '29',
    NOMBRE: 'Ricardo',
    APELLIDOS: 'Casanovas',
    CARGO: 'Operario Almacén',
    CARGO_EN: 'Warehouse Operations',
    EMAIL: 'info@3lglogistics.com',
    TELÉFONO: '+34 93 712 86 86',
  },
  {
    EQUIPOS: 'ALMACÉN',
    NUM: '30',
    NOMBRE: 'Jesús ',
    APELLIDOS: 'Martínez ',
    CARGO: 'Operario Almacén',
    CARGO_EN: 'Warehouse Operations',
    EMAIL: 'info@3lglogistics.com',
    TELÉFONO: '+34 93 712 86 86',
    undefined: '18',
  },
];
